import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import { IPhoneSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { SimpleBotDetector } from '../../../utils/simpleBotDetector';
import { BargainTermsPhones } from './phones';

const styles = require('./index.css');

export interface IBargainTermsBlockProps {
  terms: [string, string | string[]][];
  phones: IPhoneSchema[];
  sendCa(isBot?: boolean): void;
  knAuctionCompanies: number[];
  publishedUserId: number | null;
  headerTitle: string;
  isCoworking: boolean;
}

const withoutTermList = ['цена', 'ставка', 'налог', 'обеспечительный платеж'];

export class BargainTermsBlock extends React.Component<IBargainTermsBlockProps> {
  private botDetector = new SimpleBotDetector();

  public componentDidMount() {
    this.botDetector.init();
  }

  public render() {
    let { terms, phones, sendCa, knAuctionCompanies, publishedUserId, headerTitle, isCoworking } = this.props;

    //скрываые условия сделки названия которых входят в withoutTermList
    if (publishedUserId !== null && knAuctionCompanies.includes(publishedUserId)) {
      terms = terms.filter(t => !withoutTermList.includes(t[0].toLowerCase()));
    }

    const termsFirstBlockLength = Math.ceil(terms.length / 2);

    return (
      <section {...mergeStyles(styles['section'], isCoworking && styles['coworking'])}>
        <div className={styles['header']}>{headerTitle}</div>
        <div className={styles['block']}>
          <div className={styles['group']}>
            {terms.slice(0, termsFirstBlockLength).map((term, index) => (
              <div
                {...mergeStyles(
                  Array.isArray(term[1]) ? styles['item_long'] : styles['item'],
                  // Легкий костыль, для того чтобы отменить max-width
                  index === 2 && styles['extra_height'],
                )}
                key={term[0]}
              >
                <div className={styles['name']}>{term[0]}</div>
                {divide(term[1])}
              </div>
            ))}
          </div>
          <div className={styles['group']}>
            {terms.slice(termsFirstBlockLength).map(term => (
              <div className={Array.isArray(term[1]) ? styles['item_long'] : styles['item']} key={term[0]}>
                <div className={styles['name']}>{term[0]}</div>
                {divide(term[1])}
              </div>
            ))}
          </div>
        </div>
        <BargainTermsPhones
          phones={phones}
          className={styles['phones']}
          onClick={() => sendCa(!this.botDetector.isHuman())}
        />
      </section>
    );
  }
}

/**
 * Павильно делит составные элементы
 */
function divide(item: string | string[]) {
  if (Array.isArray(item)) {
    return (
      <div className={styles['value']}>
        {item[0]}
        <br />
        {item[1]}
      </div>
    );
  }

  return <div className={styles['value']}>{item}</div>;
}
